import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { AdminPanelUserOrganizationDataSectionComponent } from '../admin-panel-user-organization-data-section/admin-panel-user-organization-data-section.component';
import { AdminPanelUserDataSectionField } from '../../../../../../../../shared/models/admin-panel-user-data-section-field';

@Component({
  selector:
    'app-admin-panel-user-organization-address-and-bank-account-section',
  imports: [AdminPanelUserOrganizationDataSectionComponent],
  templateUrl:
    './admin-panel-user-organization-address-and-bank-account-section.component.html',
  styleUrl:
    './admin-panel-user-organization-address-and-bank-account-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminPanelUserOrganizationAddressAndBankAccountSectionComponent {
  fields = input.required<AdminPanelUserDataSectionField[]>();
}
